/*
 * The sheet's sub-line — "Owned by platform · 12 pages".
 *
 * Both halves are dropped when the surface cannot supply them: a doc set whose
 * entity metadata has not arrived has no owner, and a tree the reader has not
 * read yet has no count. Neither is worth inventing, so the line shortens.
 */
export const docsNavSubtitle = (
  owner: string | undefined,
  count: number,
  noun: string,
): string | undefined => {
  const parts = [
    owner ? `Owned by ${owner}` : undefined,
    count > 0 ? `${count} ${count === 1 ? noun : `${noun}s`}` : undefined,
  ].filter(Boolean);

  return parts.length > 0 ? parts.join(' · ') : undefined;
};
